<template>
	<div>
		<el-table :data="tableData" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
			<el-table-column prop="nickName" label="昵称" width="150"></el-table-column>
      		<el-table-column prop="vxin" label="微信" width="250"></el-table-column>
      		<el-table-column prop="telephone" label="电话" width="180"></el-table-column>
      		<el-table-column prop="realName" label="姓名" width="120"></el-table-column>
      		<el-table-column prop="totalGift" label="总积分" width="150"></el-table-column>
      		<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>
	</div>
</template>
<script type="text/javascript">
	import {getUserList} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:2,
		 		total:0,
		 		pageCount:0
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getUserList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getUserList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount=res.data.data.pages;
				});
			}
		}
	}
</script>